<template>
  <div class="info">
    <div class="main">
      <div class="items autoFlex">
        <span>人脸照</span>
        <div class="autoFlexNoJust">
          <img class="contents" :src="infos.personImg" alt="" />
        </div>
      </div>
      <div class="items autoFlex">
        <span>姓名</span>
        <div class="autoFlexNoJust">
          <span class="contents">{{ infos.personName }}</span>
        </div>
      </div>
      <div class="items autoFlex" v-if="infos.departId>0">
        <span>部门</span>
        <div class="autoFlexNoJust" >
          <span class="contents">{{ departmentName }}</span>
        </div>
      </div>
      <div class="items autoFlex" v-if="infos.departId<0">
        <span>公司名称</span>
        <div class="autoFlexNoJust">
          <span class="contents">{{ infos.companyName }}</span>
        </div>
      </div>
      <div class="items autoFlex">
        <span>性别</span>
        <div class="autoFlexNoJust">
          <span class="contents">{{ infos.personSex | filterSex }}</span>
        </div>
      </div>
      <div class="items autoFlex">
        <span>身份证号码</span>
        <div class="autoFlexNoJust">
          <span class="contents">{{ infos.personNo }}</span>
        </div>
      </div>
      <div class="items autoFlex">
        <span>手机号码</span>
        <div class="autoFlexNoJust">
          <span class="contents">{{ infos.phoneNum }}</span>
        </div>
      </div>
      <div class="items aiyo" style="display: flex;justify-content: space-between;align-items: center;">
        <span>预约权限</span>
        <div class="autoFlexNoJust flexss">
			<!-- <span class="" v-for="itme in 14">测试1</span> -->
         <span
            class=""
            v-for="(item, index) in infos.authorityList"
            :key="index"
            >{{ item.name }}</span
          >
        </div>
      </div>
    </div>
	<van-button type="primary" class="btnss"  @click="clears" style='margin-bottom: 30rpx;'>清除缓存</van-button>
    <van-button type="primary" class="btns" @click="beginEdit">编辑</van-button>
  </div>
</template>
<script>
import { queryPersonalInfo, getAuth,getDepartments } from "../apis/api";
import {
	Toast
} from 'vant';
export default {
  data() {
    return {
      infos: {
		  personImg:''
	  },
      showEdit: false,
      departmentName: "",
    };
  },
  filters: {
    filterSex(value) {
      return value == 0 ? "男" : "女";
    },
  },
  mounted() {
    document.title = "个人信息";
    queryPersonalInfo().then((res) => {
      console.log(res);
      this.infos = res.result;
      let id = this.infos.departId;
      getDepartments().then((xhr) => {
        console.log(xhr);
        this.options = xhr.result.map((item) => {
          item.text = item.departName;
          item.value = item.id;
          if (id == item.id) {
            this.departmentName = item.departName;
          }
          return item;
        });
      });
    });
  },
  methods: {
    beginEdit() {
      this.$router.push("/edit");
    },
	clears(){
		localStorage.clear()
		Toast('清除成功')
		//this.$router.go(-1)
    window.locaiton.reload()
	}
  },
};
</script>
<style scoped lang='less'>
.aiyo{
  min-height: 50px!important;
  height: auto!important;
  padding: 10px 0;
}
.btns {
 width: 90%;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
  background: #489fff !important;
}
.btnss{
	margin-top: 20px;
	 width: 100%;
	background: #489fff !important;
}
.info {
  background: #f7f7f7;
  padding: 20px;
  height: 100vh;
  .main {
    background: #ffffff;
    border-radius: 10px;
    padding: 0 20px;
    .items {
      height: 80px;
      border-bottom: 1px solid #ccc;
      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
	  span{
		  font-size: 24px;
	  }
      .contents {
        margin-right: 20px;
      }
    }
  }
}
.flexss {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	width: 80%;
	span{
		width: 50%;
		display: inline-block;
		text-align: center;
		
	}
}
</style>
